module.exports = __webpack_public_path__ + "media/win2.e43a85d0.mp3";